"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../constant");

var _calendar = _interopRequireDefault(require("../calendar.proptypes"));

var _default = {
  PropTypes: {
    controls: _propTypes.default.shape({
      onDepartChange: _propTypes.default.func,
      onReturnChange: _propTypes.default.func,
      selectionType: _propTypes.default.number,
      maxDays: _propTypes.default.number,
      resetData: _propTypes.default.bool,
      selectForDepart: _propTypes.default.bool,
      selectForReturn: _propTypes.default.bool,
      viewType: _propTypes.default.number,
      toggleDateSelection: _propTypes.default.func
    }),
    dataFormatDate: _propTypes.default.object,
    dataFormatCurrency: _propTypes.default.object,
    dates: _propTypes.default.shape({
      departDate: _propTypes.default.instanceOf(Date),
      returnDate: _propTypes.default.instanceOf(Date)
    }),
    enableLFC: _propTypes.default.bool,
    environment: _propTypes.default.oneOf(Object.keys(_constant.DEFAULT_LFC_ENDPOINT)),
    lfcDepartEndpoint: _propTypes.default.string,
    lfcReturnEndpoint: _propTypes.default.string,
    lfcConfig: _calendar.default.PropTypes.lfcConfig,
    theme: _propTypes.default.string,
    prefillLfcOneWayPrice: _propTypes.default.object,
    prefillLfcReturnPrice: _propTypes.default.object,
    snapLfcPrices: _propTypes.default.object,
    customDateLabels: _propTypes.default.object,
    isOnlyApplyForHotel: _propTypes.default.bool,
    isSnapCalendar: _propTypes.default.bool,
    isPartialHotelCalendar: _propTypes.default.bool,
    minNights: _propTypes.default.number,
    enableAvailableDateCalendarFlag: _propTypes.default.bool,
    flightDepart: _propTypes.default.instanceOf(Date),
    flightReturn: _propTypes.default.instanceOf(Date),
    domain: _propTypes.default.string
  },
  DefaultProps: {
    isOnlyApplyForHotel: false,
    snapLfcPrices: null,
    isSnapCalendar: false,
    isPartialHotelCalendar: false,
    enableAvailableDateCalendarFlag: false,
    domain: 'com'
  }
};
exports.default = _default;